/**
 * SlikLoader (Jose 2026-09-25, beam 2026-09-26) — the branded loading experience.
 *
 * The signature: the SLIK mark ENGRAVED on the copper→charcoal gradient with a beam of LIGHT sweeping
 * across it (no spinning ring — the sweep is the progress cue, "mostly light"). Two variants:
 *  • fullScreen — the brand splash (initial auth-resolve). Visually identical to the instant pre-React
 *    splash in public/index.html, so the cold-boot hand-off is seamless.
 *  • inline (default) — a compact self-contained gradient chip (its own gradient so it works on any
 *    page background) for route/tab transitions.
 * Styling: src/index.css (.slik-splash-*, .slik-mark, .slik-beam).
 */
import React from 'react';

const GRADIENT = 'linear-gradient(135deg, #2A211A 0%, #C0824A 100%)';
const LOGO = `${process.env.PUBLIC_URL || ''}/assets/branding/shop-logo.png`;
const FALLBACK = `${process.env.PUBLIC_URL || ''}/logo512.png`;

const onImgError = (e: React.SyntheticEvent<HTMLImageElement>) => {
  const t = e.currentTarget;
  if (!t.src.endsWith('logo512.png')) t.src = FALLBACK;
};

interface Props {
  fullScreen?: boolean;
  label?: string;
}

const SlikLoader: React.FC<Props> = ({ fullScreen = false, label }) => {
  if (!fullScreen) {
    return (
      <div className="flex items-center justify-center min-h-[50vh]">
        <div className="flex flex-col items-center gap-3">
          <div className="slik-mark" style={{ background: GRADIENT, padding: 16, borderRadius: 22 }}>
            <img src={LOGO} onError={onImgError} alt="SLIK" className="slik-splash-logo" style={{ width: 64, height: 64 }} />
            <span className="slik-beam" />
          </div>
          {label && <p className="text-sm text-gray-500">{label}</p>}
        </div>
      </div>
    );
  }
  return (
    <div className="slik-splash-full" style={{ background: GRADIENT }}>
      <div className="slik-mark">
        <img src={LOGO} onError={onImgError} alt="SLIK" className="slik-splash-logo" />
        <span className="slik-beam" />
      </div>
      {label && <p style={{ color: 'rgba(245,239,230,0.82)', fontSize: 13, marginTop: -8 }}>{label}</p>}
      <div className="slik-splash-pb">powered by <b>NEXSY</b></div>
    </div>
  );
};

export default SlikLoader;
